<template>
  <div>
    <!-- Breadcrumb -->
    <app-breadcrumb>
      <template #contentright>
      
          <span class="text-nowrap">

          </span>
      </template>
    </app-breadcrumb>

    <!-- Filters -->
    <register-plan-list-filters @search="searchAll" :status-filter.sync="statusFilter" />

    <!-- Table Container Card -->
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <b-card no-body class="mb-0">
        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <!-- Per Page -->
            <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
              <label>{{ $t('Show') }}</label>
              <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
                :clearable="false" class="per-page-selector d-inline-block mx-50" />
              <label>{{ $t('entries') }}</label>
            </b-col>
            <b-col />
          </b-row>
        </div>
        <b-table ref="refUserListTable" :items="itemsData" :fields="tableColumns" primary-key="id"
          class="position-relative table-nowrap" :sort-by.sync="sortBy" responsive show-empty
          empty-text="Không tìm thấy kết quả" :sort-desc.sync="isSortDirDesc">
          <template #cell(finished_volume)="row">
            <b-progress :max="100" show-progress variant="success" class="progress-bar-success">
              <b-progress-bar :value="row.item.finished_volume">
                <strong>{{ row.item.finished_volume }}</strong>
              </b-progress-bar>
            </b-progress>
          </template>
          <template #cell(id)="data">
            {{ data.index + 1 }}
          </template>
          
          <!-- broadcast_date -->
          <!-- <template #cell(broadcast_date)="row">

           {{ formatDate(row.item.broadcast_date) }}
          </template> -->
          <!-- End_date -->
          <template #cell(created_at)="row">

           {{ formatDateHour(row.item.created_at) }}
          </template>
          <!-- Column: Status -->
          <template #cell(status)="row">
            <b-badge pill :variant="`light-${resolveStatusVariant(row.item.status)}`" class="text-capitalize">
              {{ resolveStatusText(row.item.status) }}
            </b-badge>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="row">
            <b-button v-if="row.item.status === 20" class="ml-1 btn-icon" size="sm" variant="outline-primary"
              v-b-tooltip.hover title="Duyệt" @click="changeStatus(row.item.id, 30, 'Duyệt ')">
              <feather-icon icon="CheckIcon" />
            </b-button>
            <b-button v-if="row.item.status === 20" class="ml-1 btn-icon" size="sm" variant="outline-danger"
              v-b-tooltip.hover title="Từ chối" @click="changeStatus(row.item.id, 40, 'Từ chối ')">
              <feather-icon icon="XIcon" />
            </b-button>
            <b-button class="ml-1 btn-icon" size="sm" variant="outline-primary" @click="show(row.item)"
              v-b-tooltip.hover title="Xem thông tin chi tiết">
              <feather-icon icon="EyeIcon" />
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">{{
                $t('show_to_entries', {
                  from: dataMeta.from,
                  to: dataMeta.to,
                  of: dataMeta.of,
                })
              }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="totalEntries" :per-page="perPage" first-number last-number
                class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </b-overlay>

    <b-modal id="showDetail" body-class=" mb-2" size="xl" @close="dialog" cancel-variant="outline-secondary"
       hide-footer title="Thông tin">
      <register-plan-show :mdata="frmData" @updateData="handleDialog" />
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required, email, alphaNum, min, max } from '@validations';
import {
  BOverlay,
  BCard,
  BRow,
  BCol,
  BButton,
  BTable,
  BFormCheckbox,
  BBadge,
  BPagination,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BForm,
  BFormInvalidFeedback,
  VBTooltip,
  BProgress,
  BProgressBar,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api';
import { showToast } from '@/@core/utils/utils';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import RegisterPlanListFilters from './RegisterPlanListFilters.vue';
import useRegisterPlanApprove from './useRegisterPlanApprove';
import formValidation from '@core/comp-functions/forms/form-validation';
import store from '@/store';
import RegisterPlanEdit from './RegisterPlanEdit.vue';
import RegisterPlanShow from './RegisterPlanShow.vue';
import vSelect from 'vue-select';
import Ripple from 'vue-ripple-directive';

export default {
  components: {
    AppBreadcrumb,
    RegisterPlanListFilters,
    BOverlay,
    BCard,
    BRow,
    BCol,
    BButton,
    BTable,
    BBadge,
    BPagination,
    BFormCheckbox,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormInvalidFeedback,
    RegisterPlanEdit,
    vSelect,
    BProgress,
    BProgressBar,
    RegisterPlanShow,
  },
  data() {
    return {
      editMode: false,
    };
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const isAddNewUserSidebarActive = ref(false);
    const blankData = {
      id: null,
      name: '',
      manufacture_id: null,
      description: '',
    };
    const frmData = ref(JSON.parse(JSON.stringify(blankData)));
    const resetfrmData = () => {
      frmData.value = JSON.parse(JSON.stringify(blankData));
    };
    const padTo2Digits = (num) => num.toString().padStart(2, '0')
    const {
      loading,
      fetchAllApprove,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      resolveStatusVariant,
      resolveStatusText,
      statusFilter,
    } = useRegisterPlanApprove();

    fetchAllApprove();
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(frmData);
    return {
      fetchAllApprove,
      // Sidebar
      isAddNewUserSidebarActive,
      loading,
      tableColumns,
      perPage,
      currentPage,
      totalEntries,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      itemsData,
      frmData,
      getValidationState,
      resetfrmData,
      resolveStatusVariant,
      resolveStatusText,
      statusFilter,
      padTo2Digits
    };
  },
  methods: {
    handleDialog() {
      // this.$bvModal.hide('showDetail');
      this.fetchAllApprove();
      this.resetfrmData();
    },
    dialog() {
      this.editMode = false;
      this.resetfrmData();
      // this.$bvModal.hide('showDetail');
    },
    show(item) {
      this.frmData = item;
      this.$bvModal.show('showDetail')
    },
    changeStatus(id, status, msg, title) {
      this.$swal({
        title: title ? title : 'Bạn chắc muốn thay đổi trạng thái?',
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Có',
        cancelButtonText: 'Không',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          console.log(id, status);
          this.$store
            .dispatch('registerPlan/changeStatus', { id: id, status: status })
            .then((res) => {
              if (res.status === 200) {
                this.fetchAllApprove();
                showToast(res.data.message, { variant: 'success' });
              } else {
                showToast(res.data.message);
              }
            });
        }
      });
    },
    
    
    formatDate(value) {
      const date = new Date(value);
      return `${this.padTo2Digits(date.getDate())}-${this.padTo2Digits(date.getMonth() + 1)}-${date.getFullYear()}`;
    },
    formatDateHour(value) {
      // return moment(String(value)).format('DD-MM-YYYY HH:mm');
      const date = new Date(value);
      return `${this.padTo2Digits(date.getDate())}-${this.padTo2Digits(date.getMonth() + 1)}-${date.getFullYear()} ${this.padTo2Digits(date.getHours())}:${this.padTo2Digits(date.getMinutes())}`;
    },
    searchAll(data) {
      console.log('data_', data);
      this.searchQuery.keyword = data.keyword;
      this.searchQuery.end_date = data.end_date;
      this.searchQuery.status = data.status;
      this.searchQuery.channel_id = data.channel_id;      
      this.fetchAllApprove();
    },
  },
};
</script>
